export interface WowSetting {
  /** 是否開啟特效 */
  turnOn: boolean;
  /** 運用特效 */
  animate: string;
}

export enum EnumScrollType {
  Up,
  Down,
  UpDown
}
